exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-m-select[data-v-507ea2d0] {\n  width: 100%;\n}\n[data-v-507ea2d0] .text-area-cls .el-textarea__inner {\n  border-width: 1PX;\n}", ""]);

// exports
